import * as moment from "moment-timezone";
import { Moment } from "moment-timezone";
import { useTranslation } from "react-i18next";
import "../i18n/translation";

const GetDayList = (timeZoneId: string, language: string) => {
  const momentDates = require('moment/min/moment-with-locales');
  const date: Moment = moment.tz(timeZoneId).startOf("day");
  // Dynamically bind currentWeek or next WeekData
  const days: string[] = [
    momentDates().weekday(0).locale(language).format('dddd'),
    momentDates().weekday(1).locale(language).format('dddd'),
    momentDates().weekday(2).locale(language).format('dddd'),
    momentDates().weekday(3).locale(language).format('dddd'),
    momentDates().weekday(4).locale(language).format('dddd'),
    momentDates().weekday(5).locale(language).format('dddd'),
    momentDates().weekday(6).locale(language).format('dddd'),    
  ];
  const months: string[] = [
    momentDates().locale(language).month('0').format('MMM'),
    momentDates().locale(language).month('1').format('MMM'),
    momentDates().locale(language).month('2').format('MMM'),
    momentDates().locale(language).month('3').format('MMM'),
    momentDates().locale(language).month('4').format('MMM'),
    momentDates().locale(language).month('5').format('MMM'),
    momentDates().locale(language).month('6').format('MMM'),
    momentDates().locale(language).month('7').format('MMM'),
    momentDates().locale(language).month('8').format('MMM'),
    momentDates().locale(language).month('9').format('MMM'),
    momentDates().locale(language).month('10').format('MMM'),
    momentDates().locale(language).month('11').format('MMM'),
  ];  

  const currWeekDayNum: number = date.day(); 

  const remainingDays: number = days.length - currWeekDayNum; 
  let startDate: Moment = date.clone(),
    endDate: Moment = date.clone();

  if (currWeekDayNum < 4) {
    endDate = startDate.clone().add(remainingDays, "day"); 
  } else {
    startDate = startDate.clone().add(remainingDays, "day");
    endDate = startDate.clone().add(6, "day");
  }

  const getDaysArray = (start: Moment, end: Moment) => {
    const arr = [];
    for (let dt = start; dt <= end; dt.add(1, "day")) {
      if (dt.day() !== 0 && dt.day() !== 6) {
        arr.push(dt.clone());
      }
    }
    return arr;
  };

  const dayList: Moment[] = getDaysArray(startDate.clone(), endDate.clone());
  return {
    dayList: dayList,
    currentDate: date,
    startDate: startDate,
    days: days,
    months: months,
  };
};

export default GetDayList;